import React from "react";

const EducationList = ({ children, year, name }) => {
  return (
    <div
      className="w-full lg:w-full shadow-md px-3 py-3 mb-3"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <div className="text-xs font-extrabold" style={{ color: "#FFC837" }}>
        {year}
      </div>
      <h3 className="font-semibold text-sm">{name}</h3>
      {children}
    </div>
  );
};

export default EducationList;
